import * as React from 'react'
import { AppAntSwitch } from '@components'
import {isSiteGroup, siteGroup, sites} from '@signals'
import { Grid } from '@mui/material'
import {batch} from "@preact/signals-react";


export default function AppCommonFiltersSiteGroupToggleButton({ ...props }) {
    return <Grid item>
        <AppAntSwitch
            falseText="Sites"
            trueText="Site group"
            checked={isSiteGroup.value}
            onChange={e => batch(() => {
                isSiteGroup.value = e.target.checked
                if (!e.target.checked) {
                    siteGroup.value = null
                }else{
                    sites.value = []
                }
            })}
            {...props}
        />
    </Grid>
}